<template>
  <div>
    <header-guideline />
    <!-- <v-flex xs12 class="primary pl-1">
      <v-img
        class="align-top white--text px-10 pt-10"
        src="@/assets/images/Header-Background-bottom.png"
        height="244px"
      >
        <h2 class="fs-22 pr-5">
          Welcome to Help Center, how we can we help you?
        </h2>
        <v-flex xs8>
          <v-text-field
            height="20px"
            single-line
            rounded
            hide-details
            placeholder="Search for answer..."
            prepend-inner-icon="search"
          ></v-text-field>
        </v-flex>
      </v-img>
    </v-flex> -->
    <v-layout justify-center class="pl-7 pr-12">
      <card-guideline title="Manual Guideline" :typeCard="1" />
      <card-guideline title="Tutorial Video" :typeCard="2" />
      <card-guideline
        title="Download"
        :ver="version"
        :typeCard="3"
        @download="downloadFile"
      />
    </v-layout>
    <v-flex xs12 class="px-11 pt-10 pb-7">
      <h4 class="primary--text font-weight-bold fs-24">Popular Articles</h4>
    </v-flex>
    <v-layout class="px-11 lh-normal pb-10">
      <v-flex v-for="n in 2" :key="n" xs4 class="pr-4">
        <div class="pb-8">
          <div class="popular-article">
            <span class="subtitle-1 font-weight-bold primary--text"
              >Dashboard</span
            >
          </div>
          <p class="grey--text text--darken-1 caption pt-3 mb-3">
            Coming soon
          </p>
          <a class="bluePurple--text caption font-weight-bold">Read More</a>
        </div>
        <div v-for="n in 2" :key="n" class="pb-8">
          <div class="popular-article">
            <span class="subtitle-1 font-weight-bold primary--text"
              >Articles with no maximum lines for making the help center helpful
              and solutive</span
            >
          </div>
          <p class="grey--text text--darken-1 caption pt-3 mb-3">
            Coming soon.
          </p>
          <a class="bluePurple--text caption font-weight-bold">Read More</a>
        </div>
      </v-flex>
      <v-flex xs4 class="pr-5">
        <v-card class="card-support rounded-24 menuActive py-5 px-7 mb-10">
          <v-card-text class="pa-0">
            <h4 class="fs-18 white--text">Need Support?</h4>
            <p class="fs-12 white--text mt-3">
              Please let us know if you have any questions or need additional
              information.
            </p>
          </v-card-text>
          <v-card-actions class="pa-0 mt-10">
            <v-btn
              color="white"
              rounded
              class="text-capitalize menuActive--text lh-17 font-weight-700 px-5"
              :to="{ name: 'Support' }"
            >
              Contact Support
            </v-btn>
          </v-card-actions>
        </v-card>
        <div class="release-notes">
          <span class="fs-18 font-weight-bold primary--text">
            Release Notes
          </span>
          <ul class="pl-5 bluePurple--text">
            <li v-for="n in 3" :key="n">
              <span class="fs-14 primary--text lh-16">
                Coming soon
              </span>
              <p class="caption greyDisabled--text mb-2">
                Tue, April 28, 2020
              </p>
            </li>
          </ul>
          <a class="bluePurple--text caption font-weight-bold ml-1">
            See all updates
          </a>
        </div>
      </v-flex>
    </v-layout>
    <v-layout class="box-message">
      <v-menu
        v-model="boxMessage"
        class="contact-support"
        offset-y
        :close-on-content-click="false"
      >
        <template v-slot:activator="{ on, attrs }">
          <v-btn
            color="primary"
            dark
            v-bind="attrs"
            v-on="on"
            class="text-capitalize pa-5 pr-3 fs-14 font-weight-bold rounded-24"
          >
            Help
            <img
              class="ml-2"
              src="@/assets/images/icon/help-circle-white.png"
            />
          </v-btn>
        </template>
        <v-card min-width="350" class="elevation-card rounded-24">
          <v-card-title class="primary py-3">
            <div class="pl-2">
              <span class="white--text fs-20 lh-24 font-weight-bold"
                >Contact Support</span
              >
              <p class="caption white--text mb-0 fs-12">Send us a message</p>
            </div>
            <v-spacer></v-spacer>
            <v-btn dark icon @click="boxMessage = false">
              <v-icon>close</v-icon>
            </v-btn>
          </v-card-title>
          <v-card-text class="px-2">
            <v-col cols="12">
              <v-text-field
                placeholder="Name"
                outlined
                rounded
                dense
              ></v-text-field>
              <v-text-field
                placeholder="Email"
                outlined
                rounded
                dense
              ></v-text-field>
              <v-text-field
                placeholder="Subject"
                outlined
                rounded
                dense
              ></v-text-field>
              <v-textarea
                placeholder="Message"
                class="rounded-15"
                outlined
                rounded
                rows="4"
                dense
              ></v-textarea>
              <v-col cols="12" class="text-right pa-0">
                <v-btn
                  color="menuActive"
                  dark
                  small
                  class="text-capitalize px-8 py-4 fs-14 font-weight-bold rounded-24"
                >
                  Submit
                </v-btn>
              </v-col>
            </v-col>
          </v-card-text>
        </v-card>
      </v-menu>
    </v-layout>
  </div>
</template>

<script>
import headerGuideline from '../../../components/contentManagement/header';
import cardGuideline from '../../../components/contentManagement/card';
import Swal from 'sweetalert2';

export default {
  components: {
    'header-guideline': headerGuideline,
    'card-guideline': cardGuideline
  },
  data() {
    return {
      fab: false,
      docsEn: '',
      docsId: '',
      version: '',
      baseUrl: process.env.VUE_APP_BASE_URL,
      boxMessage: false
    };
  },
  mounted() {
    this.getDetail();
  },
  methods: {
    async getDetail() {
      this.progressDialogLoading = true;
      this.loading = true;
      await this.$store
        .dispatch('docs/getAll', {
          limit: 1,
          sort: 'desc'
        })
        .then(data => {
          console.log(data);
          this.progressDialogLoading = false;
          this.loading = false;
          if (data.code === 200) {
            this.docsEn = data.data.result[0].document_en;
            this.docsId = data.data.result[0].document_id;
            this.version = data.data.result[0].version;
          } else {
            Swal.fire('Failed!', data.response.data.message.text_en, 'error');
          }
        })
        .catch(err => {
          console.log(err.response);
          Swal.fire('Failed!', err.response.data.message.text_en, 'error');
          this.progressDialogLoading = false;
          this.loading = false;
        });
    },
    downloadFile(type) {
      if (this.docsId === '' || this.docsEn === '') {
        Swal.fire(
          'Failed!',
          'Guideline document have not been inputted.',
          'error'
        );
      } else {
        console.log(type);
        let fileName = type === 'id' ? this.docsId : this.docsEn;
        let file = encodeURIComponent(fileName);
        window.open(
          this.baseUrl +
            '/v1/download/file?name=' +
            file +
            '&token=' +
            localStorage.getItem('app_token'),
          '_blank'
        );
      }
    }
  }
};
</script>

<style scoped>
.card-support {
  background-image: url('../../../assets/images/bg-support-rounded.png');
  background-position: 92% 85%;
  height: 214px;
}
.box-message {
  position: fixed !important;
  bottom: 31px;
  right: 17px;
  z-index: 2;
}
.box-message .v-speed-dial {
  position: fixed;
  bottom: 5%;
}
.box-message .v-btn--floating {
  position: relative;
}
</style>
